import PlayArrow from "@mui/icons-material/PlayArrow";
import { Button, ButtonProps } from "@mui/material";

type Props = Pick<
  ButtonProps,
  "onClick" | "loading" | "disabled" | "variant" | "fullWidth"
>;

export const ConductCohortButton = (props: Props) => {
  return (
    <Button
      variant={props.variant ?? "contained"}
      size="small"
      color="primary"
      loadingPosition="start"
      startIcon={<PlayArrow />}
      {...props}
    >
      Conduct Cohort
    </Button>
  );
};
